import React, { useEffect, useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    TextField,
    Button,
    useMediaQuery,
} from '@mui/material';
import { SaveAlt as DownloadIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Users = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [cusData, setCusData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [filterText, setFilterText] = useState('');
    console.log(filteredData, "filteredData")
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isIpadMini = useMediaQuery('(min-width: 768px) and (max-width: 834px)');

    useEffect(() => {
        const fetchCostSavingsDetails = async () => {
            const user = JSON.parse(sessionStorage.getItem("user"));
            const url = process.env.REACT_APP_SERVER_URL + "/savyandsons/customeriicostdetails";
            const config = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.accessToken
                },
            };
            try {
                const response = await fetch(url, config);
                if (response.ok) {
                    const fetchedData = await response.json();
                    setData(fetchedData);
                    // setFilteredData(fetchedData);
                    console.log("Fetched insuranceDetails:", fetchedData); // Debugging fetched data
                } else {
                    console.error('Failed to fetch insurance details');
                }
            } catch (error) {
                console.error('Error fetching insurance details:', error);
            }
        }
        fetchCostSavingsDetails();
    }, []);

    useEffect(() => {
        const fetchCusDetails = async () => {
            const user = JSON.parse(sessionStorage.getItem("user"));
            const url = process.env.REACT_APP_SERVER_URL + "/savyandsons/allcustomerinfo";
            const config = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.accessToken
                },
            };
            try {
                const response = await fetch(url, config);
                if (response.ok) {
                    const fetchedData = await response.json();
                    setCusData(fetchedData);
                    setFilteredData(fetchedData);
                    console.log("Fetched insuranceDetails:", fetchedData); // Debugging fetched data
                } else {
                    console.error('Failed to fetch insurance details');
                }
            } catch (error) {
                console.error('Error fetching insurance details:', error);
            }
        }
        fetchCusDetails();
    }, []);

    // Handle Pagination Change
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const COLORS = {
  bg: "#FAFAFA",          // page background
  card: "#FFFFFF",       // table background
  border: "#E5E7EB",     // subtle border
  title: "#111827",      // near-black text
  accent: "#F5C400",     // brand yellow (CTA only)
  accentSoft: "#FFF4CC", // soft yellow (header bg alternative)
  headerBg: "#1F2937",   // dark slate (BEST for table header)
  headerText: "#FFFFFF", // white header text
  grid: "#E5E7EB",
};


    // Handle Filter Change
    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
        const filtered = cusData.filter((item) =>
            item?.firstName?.toLowerCase().includes(event.target.value.toLowerCase())
        );
        setFilteredData(filtered);
    };

   const downloadExcel = () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("I&I Cost Savings Data");

  /* ===================== COLUMNS ===================== */
  worksheet.columns = [
    // CUSTOMER
  { header: "Company", key: "company", width: 25 },
    { header: "First Name", key: "firstName", width: 18 },
    { header: "Last Name", key: "lastName", width: 18 },
    { header: "Email", key: "email", width: 30 },
    { header: "Phone", key: "phone", width: 18 },
      { header: "Date And Time", key: "crtTs", width: 18 },
    

    // INFILTRATION RATES
    { header: "Rate Infiltration (GPM)", key: "rateInfiltrationGpmi", width: 20 },
    { header: "Rate Infiltration (GPH)", key: "rateInfiltrationGph", width: 20 },
    { header: "Rate Infiltration (GPD)", key: "rateInfiltrationGpd", width: 20 },
    { header: "Rate Infiltration (GPMO)", key: "rateInfiltrationGpmo", width: 22 },
    { header: "Rate Infiltration (GPY)", key: "rateInfiltrationGpy", width: 20 },

    // TREATMENT COSTS
    { header: "Cost Treat / Minute", key: "costTreatPerMinute", width: 20 },
    { header: "Cost Treat / Hour", key: "costTreatPerHour", width: 20 },
    { header: "Cost Treat / Day", key: "costTreatPerDay", width: 20 },
    { header: "Cost Treat / Month", key: "costTreatPerMonth", width: 22 },
    { header: "Cost Treat / Year", key: "costTreatPerYear", width: 22 },

    // ROI & SAVINGS
    { header: "SS Average Cost", key: "ssAverageCost", width: 20 },
    { header: "Year One ROI", key: "yearOneRoi", width: 18 },
    { header: "Investment Return Timing", key: "investmentReturnTiming", width: 26 },
  ];

  /* ===================== ROWS ===================== */
  data.forEach((row) => {
    worksheet.addRow({
      company: row.company,
      firstName: row.firstName,
      lastName: row.lastName,
      email: row.email,
      phone: row.phone,
      crtTs: row.crtTs,

      rateInfiltrationGpmi: row.rateInfiltrationGpmi,
      rateInfiltrationGph: row.rateInfiltrationGph,
      rateInfiltrationGpd: row.rateInfiltrationGpd,
      rateInfiltrationGpmo: row.rateInfiltrationGpmo,
      rateInfiltrationGpy: row.rateInfiltrationGpy,

      costTreatPerMinute: row.costTreatPerMinute,
      costTreatPerHour: row.costTreatPerHour,
      costTreatPerDay: row.costTreatPerDay,
      costTreatPerMonth: row.costTreatPerMonth,
      costTreatPerYear: row.costTreatPerYear,

      ssAverageCost: row.ssAverageCost,
      yearOneRoi: row.yearOneRoi,
      investmentReturnTiming: row.investmentReturnTiming,
    });
  });

  /* ===================== HEADER STYLING ===================== */
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = {
      bold: true,
      color: { argb: COLORS.bg },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: {argb: "FFF5C400"}, // dark slate
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  });

  /* ===================== AUTO FILTER ===================== */
 if (worksheet.columnCount > 0) {
  worksheet.autoFilter = {
    from: "A1",
    to: `${String.fromCharCode(64 + worksheet.columnCount)}1`,
  };
}


  /* ===================== DOWNLOAD ===================== */
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "II_Cost_Savings_Report.xlsx");
  });
};


    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (

        <Box sx={{ p: 2, maxWidth: '100%', mt: 5 }}>
            <Navbar handleDrawerToggle={handleDrawerToggle} />
            <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 2,
                    mb: 2,
                    width: isMobile ? '100%' : 'calc(100% - 240px)',
                    transition: 'margin 0.3s ease-in-out, width 0.3s ease-in-out',
                    marginLeft: isMobile ? '0' : '0px',
                    // padding: isIpadMini ? '0 20px' : '0 32px', // Adjust padding for iPad Mini
                }}
            >
                <TextField
                    label="Search"
                    variant="outlined"
                    value={filterText}
                    onChange={handleFilterChange}
                    fullWidth={isMobile}  // Make full width on mobile
                    sx={{ flex: isMobile ? '1 1 100%' : '1 1 auto' }}
                />
              <Button
  variant="contained"
  sx={{
    backgroundColor: "#F3C26B",
    color: COLORS.title,
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "#F3C26B",
    },
  }}
  startIcon={<DownloadIcon />}
  onClick={downloadExcel}
>
  Download
</Button>

            </Box>
            <TableContainer component={Paper} sx={{ overflowX: 'auto', marginLeft: isMobile ? '60' : '0px', padding: isMobile ? '0 16px' : '0' }}>
                <Table >
                    <TableHead sx={{ backgroundColor: '#F3C26B' }}>
                        <TableRow>
                            <TableCell sx={{ color: COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>Company</TableCell>
                            <TableCell sx={{ color:COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>First Name</TableCell>
                            <TableCell sx={{ color:COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>Last Name</TableCell>
                            <TableCell sx={{ color: COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>Email</TableCell>
                            <TableCell sx={{ color: COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>Phone</TableCell>
                              <TableCell sx={{ color: COLORS.pg,  fontWeight: 700, whiteSpace: 'nowrap' }}>Date And Time</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.company}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.firstName}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.lastName}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {row.email}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.phone}</TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.crtTs}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </Box>
    );
};

export default Users;
